import styled from '@emotion/styled'
import { Dropdown, theme } from '@hhgtech/hhg-components'

export const StyledPhoneInputWrapper = styled.div`
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: ${theme.borderRadius};
`

export const StyledDropdown = styled(Dropdown)`
  z-index: 10;
  min-width: 105px;
  background: ${theme.colors.gray100};
  border-radius: 6px 0 0 6px;
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  &:focus {
    outline: none;
  }
`
